import { IProgressStep, IProperty } from '@/models/property.model';
import { showApiErrors } from '@/utils';
import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { TPropertyFiltersValues } from '../helpers';
import { getProperties, getProperty } from './actionCreators';
import { initialState, PROPERTIES_SLICE_NAME, PropertiesState } from './models';

export const slice = createSlice({
  name: PROPERTIES_SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    applyFilters(state: PropertiesState, action: PayloadAction<TPropertyFiltersValues>) {
      state.appliedFilters = { ...(state.appliedFilters || {}), ...action.payload };
    },
    applySoldFilters(state: PropertiesState, action: PayloadAction<TPropertyFiltersValues>) {
      state.appliedSoldFilters = { ...(state.appliedSoldFilters || {}), ...action.payload };
    },

    setProperty(state: PropertiesState, action: PayloadAction<IProperty | null>) {
      state.property = action.payload;
    },

    updatePropertyProgress(
      state: PropertiesState,
      action: PayloadAction<{
        PK: string;
        progress: IProgressStep[];
      }>,
    ) {
      state.properties = (state.properties ?? []).map((property) => {
        if (property.PK === action.payload.PK) {
          return {
            ...property,
            progress: action.payload.progress,
          };
        }
        return property;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProperties.fulfilled, (state: PropertiesState, action) => {
        const { payload, meta } = action;
        state.properties = payload.items;
        state.pagination = { ...payload.cursor, limit: meta.arg.limit };
        state.itemsCount = payload.items_count;
        state.isSold = meta.arg.isSold ?? false;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getProperty.fulfilled, (state: PropertiesState, action) => {
        const { payload } = action;
        state.property = payload;
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(isPending(getProperties, getProperty), (state: PropertiesState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getProperties, getProperty), (state: PropertiesState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;

export const { resetState, applyFilters, applySoldFilters, setProperty, updatePropertyProgress } = slice.actions;
